export default __webpack_public_path__ + "static/media/package-tracker.2b197f98.jpg";